import React from 'react';
import { renderToString } from 'react-dom/server';

import { FileVideoIcon } from '../../../icon/regular';
import {
  InstructionCSSClasses,
  InstructionEvent,
  InstructionActionTooltip,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class VideoInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return VideoInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    VideoInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.VIDEO_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.VIDEO_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.VIDEO_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<FileVideoIcon style={{ height: 20 }} />),
      title: 'Video',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.video;
  }

  openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_VIDEO_INSTRUCTION_MODAL,
      {
        instructionId,
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_VIDEO_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_VIDEO_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default VideoInstructionBlock;
